import styled from 'styled-components'
import { device } from 'src/common/theme/mediaQueries'

export const StyledForm = styled.form`
    background-color: ${props => props.theme.main.colors.inverseColor};
    
    .form-row {
        margin-bottom: 14px;
        
        &.with-checkbox {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
    
    .forgot-password-link {
        padding-left: 20px;
        text-decoration: underline;
        
        :hover {
            text-decoration: none;
        }
    }
    
    .form-action {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }
    
    label {
        padding-bottom: 4px;
    }
    
    @media ${device.tablet} {
        .forgot-password-link {
            padding-left: 0;
        }
    }
    
    @media ${device.mobileL} {
        .form-action {
            margin-top: 20px;
        }
    }
`

export const StyledErrorBlock = styled.div`
    color: ${props => props.theme.main.colors.errorColor};
    font-size: 13px;
    width: 100%;
    margin-bottom: 24px;
    
    span {
      width: 50%;
      width: 50%;
      display: block;
      margin: 0 auto;
      padding-left: 10px;
    }
`
